import React, { createContext, useReducer } from 'react';
import config from 'config';
import PropTypes from 'prop-types';

// action - menu reducer
const actionTypes = {
	set: '@customization/SET_MENU',
	toggle: '@customization/MENU_TOGGLE',
	open: '@customization/MENU_OPEN',
};

export const initialState = {
	isOpen: [],
	defaultId: 'default',
	fontFamily: config.fontFamily,
	borderRadius: config.borderRadius,
	opened: true,
};

export const MenuContext = createContext();

const menuReducer = (state, action) => {
	let id;
	switch (action.type) {
		case actionTypes.open:
			id = action.id;
			return {
				...state,
				isOpen: [id],
			};
		case actionTypes.set:
			return {
				...state,
				opened: action.opened,
			};
		default:
			return state;
	}
};

const MenuProvider = ({ children }) => {
	const [state, dispatch] = useReducer(menuReducer, initialState);

	return <MenuContext.Provider value={{ state, dispatch }}>{children}</MenuContext.Provider>;
};

MenuProvider.propTypes = {
	children: PropTypes.node,
};

const useMenu = () => {
	const context = React.useContext(MenuContext);
	if (context === undefined) {
		throw new Error('useMenu must be used within a MenuProvider');
	}
	return context;
};

export { MenuProvider, useMenu };
